import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { OrgSwitcher } from '../../features/auth/OrgSwitcher';
import { TimerWidget } from '../../features/time';
import { pageTitleFor } from './nav';

export interface TopbarProps {
  onMenuClick: () => void;
}

/** Topbar: page title + org switcher + user menu. */
export function Topbar({ onMenuClick }: TopbarProps) {
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-grey-200 bg-white/90 px-4 backdrop-blur-lg sm:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        className="rounded-lg p-2 text-grey-500 transition-colors hover:bg-grey-100 hover:text-secondary lg:hidden"
        aria-label="Open navigation"
      >
        <Menu className="h-5 w-5" aria-hidden />
      </button>

      <h1 className="min-w-0 flex-1 truncate text-heading-4 font-black text-secondary">
        {pageTitleFor(pathname)}
      </h1>

      <TimerWidget />
      {/* ⚠ NO USER MENU. The app rail (bottom-left) owns identity and sign
          out for every ecosystem app; a second sign-out here was the same
          control twice (Jesse, 2026-08-19). The rail is the shared chrome —
          this bar is the APP's. */}
      <OrgSwitcher />
    </header>
  );
}
